export const Home = {
    home: 'Home',
    login: 'login',
    shops: 'Stores',
    goodsList: 'All Goods',
    orders: 'Foreign Oreders',
    login: 'Login',
    searchPlaceHolder: 'Search',
    favs: 'Favorits',
    aboutUs: 'About Us',
    shopsSearchPlaceHolder: 'Stores Search',
    copyRight: 'all rigths reserved for Hyper Bussiness Group',
    NotFoundShop: 'there is no store with this name',
    NotFoundGoods: 'there is no Goods in this category',
    From: 'from',
    To: 'to',
}